import Config from '@config';
import { IAppMessage } from '@typings';
import { mapAppMessageRecord } from '@utils/app-message-mappers';
import MLALogger from '@utils/logger';
import Airtable from 'airtable';

/** Airtable table name; must match the runbook and `scripts/airtable/create-app-messages-table.mjs`. */
export const APP_MESSAGES_TABLE = 'App_Messages';

/** react-query key shared by the prefetcher and `useAppMessages`. */
export const APP_MESSAGES_QUERY_KEY = 'app-messages';

const base = new Airtable({ apiKey: Config.AIRTABLE_API_KEY }).base(Config.AIRTABLE_BASE_ID);

/**
 * Reads all active `App_Messages` rows, sorted by `Order`. Mirrors `fetchPicSearchData`: build the
 * base once, `select(...).all()`, map, log and rethrow so react-query handles retries and the UI
 * fails open (renders nothing) when Airtable is unavailable.
 */
export const fetchAppMessages = async (): Promise<IAppMessage[]> => {
    try {
        const records = await base(APP_MESSAGES_TABLE)
            .select({
                filterByFormula: '{Active} = TRUE()',
                sort: [{ field: 'Order', direction: 'asc' }],
            })
            .all();

        return records.map(mapAppMessageRecord).filter((message): message is IAppMessage => message !== null);
    } catch (error) {
        MLALogger.Log(['app-messages'], error, 'error');
        throw new Error(
            `Failed to fetch ${APP_MESSAGES_TABLE} from Airtable: ${
                error instanceof Error ? error.message : 'Unknown error'
            }`
        );
    }
};
